// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__vcNDC","onPage":"Pagination_onPage__1j9QP"};